import React from "react";
import { useNavigate } from "react-router-dom";

import { NotFound } from "igfd-ui/src/app-index";

export const NotFoundPage = () => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return <NotFound goBack={goBack} />;
};
